import React, { createContext, useContext, useEffect, useState } from 'react';
import { useNotifications } from './NotificationContext';

const SavedJobsContext = createContext();

export function SavedJobsProvider({ children }){
  const [saved, setSaved] = useState(() => {
    try {
      const raw = localStorage.getItem('savedJobs');
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  });

  useEffect(() => {
    try { localStorage.setItem('savedJobs', JSON.stringify(saved)); } catch (e) {}
  }, [saved]);

  const { addNotification } = useNotifications();

  function saveJob(job){
    setSaved((s) => {
      if (s.find(j => j.id === job.id)) return s;
      const next = [job, ...s];
      try { addNotification && addNotification({ text: `Saved job: ${job.title}` }); } catch(e){}
      return next;
    });
  }

  function removeJob(jobId){
    setSaved((s) => s.filter(j => j.id !== jobId));
  }

  function isSaved(jobId){
    return saved.some(j => j.id === jobId);
  }

  return (
    <SavedJobsContext.Provider value={{ saved, saveJob, removeJob, isSaved }}>
      {children}
    </SavedJobsContext.Provider>
  );
}

export function useSavedJobs(){
  return useContext(SavedJobsContext);
}

export default SavedJobsContext;
